<template>
  <div>
    <app-cells><h1 class="title">Analytics</h1></app-cells>
    <app-tabs v-if="showTabs" :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ProductStorageAnalyticsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'product-storage-analytics-general', label: 'General' },
        { name: 'product-storage-analytics-transfers', label: 'Transfers' },
        { name: 'product-storage-analytics-orders', label: 'Orders' },
      ]
    }
  },
  computed: {
    showTabs() {
      return this.$store.state.userGroups.some(group => group.code === 'general_manager' || group.code === 'product_storage_supervisor')
    }
  },
}
</script>
